import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import { PACKAGES_BASE_QUERY_KEY } from '@/api/packages/get-packages-dashboard'
import { PackageModel } from '@/models'
import { composeFormData } from '@/utils'
import { resetQueries } from '@/utils/api'

interface UpdatePackageCommentRequest {
  id: number
  comment: string
}

export const updatePackageComment = async ({
  id,
  ...data
}: UpdatePackageCommentRequest): Promise<PackageModel> => {
  const response = await authAPI.put<PackageModel>(`/packages/${id}`, composeFormData(data), {
    headers: {
      'content-type': 'multipart/form-data',
    },
  })
  return response.data
}

export const useUpdatePackageComment = () => {
  return useMutation({
    mutationFn: updatePackageComment,
    onSuccess: () => {
      resetQueries([PACKAGES_BASE_QUERY_KEY])
    },
  })
}
